import config from "../config";
import { fetchWithToken } from "../contexts/AuthContext";

const API = config.apiUrl;

// multipart uploads can't use fetchWithToken because it hardcodes Content-Type: application/json.
// let the browser set the boundary automatically by omitting Content-Type here.
async function uploadWithToken(url, formData) {
  const token = localStorage.getItem("access_token");
  const csrf = document.cookie.match(/csrf_access_token=([^;]+)/)?.[1] || "";

  const res = await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrf,
    },
    body: formData,
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function uploadProfilePic(file) {
  const fd = new FormData();
  fd.append("file", file);
  return uploadWithToken(`${API}/upload/profile-pic`, fd);
}

export async function removeProfilePic() {
  const res = await fetchWithToken(`${API}/upload/profile-pic`, { method: "DELETE" });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function uploadListingImage(listingId, file) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("listing_id", listingId);
  return uploadWithToken(`${API}/upload/listing-image`, fd);
}

export async function removeListingImage(imageId) {
  const res = await fetchWithToken(`${API}/upload/listing-image/${imageId}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function fetchListingImages(listingId) {
  const res = await fetchWithToken(`${API}/upload/listing-images/${listingId}`);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function reorderListingImages(listingId, orderedIds) {
  const res = await fetchWithToken(`${API}/upload/listing-images/${listingId}/reorder`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ordered_ids: orderedIds }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
